import { Link } from '@alfa-retail-react/components';
import React from 'react';

const AgreementDocumentLink = ({ title, url }: { title: string, url: string }) => (
    <Link
        view="default"
        className="agreementDocumentLink"
        href={url}
        target="_blank"
    >
        {title}
    </Link>
);

export const AgreementTermsLink = ({ title }: { title: string }) => (
    <AgreementDocumentLink 
        title={title}
        url="https://www.alfabank.by/upload/docs/bank/polit-konfend-angl-rus.pdf"
    />
);

export const MarketingCommunicationLink = () => (
    <AgreementDocumentLink 
        title="согласие" 
        url="https://www.alfabank.by/upload/docs/bank/Usloviya-po-obrabotke-personalnykh-dannykh-s-razyasneniem-prav-subekta-personalnykh-dannykh.pdf"
    />
);
